<template>
  <div class="content">
    <!-- 快捷菜单 -->
    <div class="shortcutMenu">
      <p class="headline">快捷菜单</p>
      <div class="menuCont">
        <template v-for="(item, index) in menuData">
          <div class="option" :key="index">
            <div class="details">
              <img :src="item.imgUrl" alt />
            </div>
            <p>{{ item.title }}</p>
          </div>
        </template>
      </div>
    </div>

    <div class="modules">
      <!-- 基础统计 -->
      <div class="lft">
        <div class="statistics">
          <div class="headline">
            <p>
              基础统计
              <span class="colorFont">更多></span>
            </p>
            <el-radio-group v-model="radio3" size="small">
              <el-radio-button label="今日"></el-radio-button>
              <el-radio-button label="近七天"></el-radio-button>
              <el-radio-button label="近30天"></el-radio-button>
            </el-radio-group>
          </div>
          <div class="cont">
            <div class="box box1">
              <div class="img">
                <img src="../../../../public/img/vipImg/huangguan.png" alt />
              </div>
              <div class="flex_3_cont">
                <div>新增会员数量</div>
                <div>{{ statData.member.today || 0 }}</div>
              </div>
            </div>
            <div class="box box2">
              <ul>
                <li>
                  <div>汽油</div>
                  <div>销量</div>
                </li>
                <li>
                  <div>金额</div>
                  <div>2000</div>
                </li>
                <li>
                  <div>升数</div>
                  <div>25</div>
                </li>
                <li>
                  <div>单数</div>
                  <div>40</div>
                </li>
              </ul>
            </div>
            <div class="box box3">
              <ul>
                <li>
                  <div>汽油</div>
                  <div>销量</div>
                </li>
                <li>
                  <div>金额</div>
                  <div>2000</div>
                </li>
                <li>
                  <div>升数</div>
                  <div>25</div>
                </li>
                <li>
                  <div>单数</div>
                  <div>40</div>
                </li>
              </ul>
            </div>
            <div class="box box4">
              <div class="img">
                <img
                  src="../../../../public/img/vipImg/chongzhibeifen.png"
                  alt
                />
              </div>
              <div class="flex_3_cont">
                <div>会员充值金额</div>
                <div>{{ statData.recharge_amount || 0 }}</div>
              </div>
            </div>
            <div class="box box5">
              <div class="img">
                <img src="../../../../public/img/vipImg/shouru.png" alt />
              </div>
              <div class="flex_3_cont">
                <div>综合收入</div>
                <div>{{ statData.today_amount || 0 }}</div>
              </div>
            </div>
            <div class="box box6">
              <div class="img">
                <img src="../../../../public/img/vipImg/duihuakuang.png" alt />
              </div>
              <div class="flex_3_cont">
                <div>短信发送量</div>
                <div>0</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 系统提醒 -->

        <div class="statistics system">
          <div class="headline">
            <p>系统提醒</p>
          </div>
          <template>
            <el-tabs v-model="activeName" type="card">
              <el-tab-pane label="用户管理" name="first">
                <div class="tags">
                  <template v-for="(item, index) in tagsData">
                    <el-tag :key="index" :color="item.color">{{
                      item.title
                    }}</el-tag>
                  </template>
                </div>
                <template>
                  <el-table :data="tableData" border style="width: 100%">
                    <el-table-column prop="date" label="日期"></el-table-column>
                    <el-table-column prop="name" label="姓名"></el-table-column>
                    <el-table-column prop="name" label="姓名"></el-table-column>
                    <el-table-column
                      prop="address"
                      label="地址"
                    ></el-table-column>
                  </el-table>
                </template>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
      </div>
      <div class="rgt">
        <div class="top">
          <div class="todaysales">
            <div class="headline">
              <img src="../../../../public/img/vipImg/zongxiaoliang.png" alt />
              <span>今日总销量</span>
            </div>
            <div class="todaysales-cont">
              <template v-for="(item, index) in salesvolume">
                <div :key="index">
                  <p>
                    <img :src="item.img" alt />
                    {{ item.text }}
                  </p>
                  <p class="colorBule">{{ item.num }}</p>
                </div>
              </template>
            </div>
          </div>
          <div class="todaysales pay">
            <div class="todaysales-cont">
              <template v-for="(item, index) in payNum">
                <div :key="index">
                  <p :style="`background:url(${item.img})`">{{ item.text }}</p>
                  <p class="colorBule">{{ item.num }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="btm">
          <div class="headline">系统公告</div>
          <div class="smallhead">最新公告</div>
          <template v-for="val in 3">
            <div :key="val" class="cont">
              <div class="ggCont">我是公告内容，我是公告标题。</div>
              <div class="ggHint">点击查看></div>
            </div>
          </template>

          <div class="smallhead">热门信息</div>
          <template v-for="val in 3">
            <div :key="val" class="cont">
              <div class="ggCont">我是公告内容，我是公告标题。</div>
              <div class="ggHint">点击查看></div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- <div class="bodycontent"> -->
<!-- 今日统计 -->
<!-- <div class="stat">
        <div class="stat_title">数据概况信息</div>
        <div class="stat_item">
          <div class="item" v-for="item in statItems" :key="item.id" :style="{background:item.bgc}">
            <div class="left"></div>
            <div class="right">
              <div class="top_line">{{item.value}}</div>
              <div>{{item.name}}</div>
            </div>
          </div>
        </div>
    </div>-->
<!-- 用户数量 -->
<!-- <div class="user"> -->
<!-- 会员用户 -->
<!-- <div class="user_item">
          <div class="user_title">
            会员信息
            <span style="float:right">(单位:人)</span>
          </div>
          <div class="user_detail">
            <div class="detail_item" v-for="item in user" :key="item.id">
              <div class="item_num">{{item.num}}</div>
              <div>{{item.name}}</div>
            </div>
          </div>
        </div>
    </div>-->
<!-- </div> -->

<script>
import { general } from "@/api/vip";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      tableData: [],
      activeName: "first",
      radio3: "今日",
      statData: {}, //统计数据
      tagsData: [
        { title: "今天过生日的会员", color: "#51ADFF" },
        { title: "未来三天过生日的会员", color: "#FF5E6E" },
        { title: "未来七天过生日的会员", color: "#6C85FF" },
        { title: "发送短信", color: "#FF7B55" },
        { title: "发送优惠券", color: "#72BDFF" }
      ],
      statItems: [
        { name: "今日销售总额", value: "￥0.00", bgc: "#5cb87a" },
        { name: "今日收入现金", value: "￥0.00", bgc: "#e6a23c" },
        { name: "今日充值总额", value: "￥0.00", bgc: "#f56c6c" },
        { name: "今日新增会员", value: "0", bgc: "#409eff" }
      ],
      user: [
        { name: "今日新增", num: "0" },
        { name: "昨日新增", num: "0" },
        { name: "本月新增", num: "0" },
        { name: "用户总数", num: "0" }
      ],
      payNum: [
        {
          text: "微信支付",
          num: "0",
          img: require("../../../../public/img/vipImg/wx.png")
        },
        {
          text: "支付宝支付",
          num: "0",
          img: require("../../../../public/img/vipImg/zfb.png")
        },
        {
          text: "现金支付",
          num: "0",
          img: require("../../../../public/img/vipImg/xj.png")
        }
      ],
      salesvolume: [
        {
          text: "金额",
          num: "0",
          img: require("../../../../public/img/vipImg/price.png")
        },
        {
          text: "升数",
          num: "0",
          img: require("../../../../public/img/vipImg/zongshengsu.png")
        },
        {
          text: "单数",
          num: "0",
          img: require("../../../../public/img/vipImg/dingdanshu.png")
        }
      ],
      menuData: [
        //
        {
          title: "收银台",
          imgUrl: require("../../../../public/img/vipImg/moneyshoukuan.png")
        },
        {
          title: "交班",
          imgUrl: require("../../../../public/img/vipImg/jiaoban.png")
        },
        {
          title: "客户召回",
          imgUrl: require("../../../../public/img/vipImg/kehuzhaohui.png")
        },
        {
          title: "扫码核销",
          imgUrl: require("../../../../public/img/vipImg/saomahexiao.png")
        },
        {
          title: "电子优惠券",
          imgUrl: require("../../../../public/img/vipImg/dianziyouhuiquan.png")
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  methods: {
    getData() {
      var data = {
        token: this.token,
        app_id: this.app_id
      };
      general(data).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.statData = res.data;
        } else {
          this.$message(res.msg);
        }
      });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0px 15px 20px 0;
  height: 100%;
  background: #f1f2f6;
  .shortcutMenu {
    width: 100%;
    background: #fff;
    padding: 20px 30px;
    .headline {
      font-size: 14px;
    }
    .menuCont {
      margin-top: 18px;
      display: flex;
      margin-bottom: 10px;
      .option {
        margin: 0 15px;
        margin-right: 30px;
        .details {
          width: 60px;
          height: 60px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        p {
          text-align: center;
          margin-top: 10px;
        }
      }
    }
  }
  .modules {
    margin-top: 10px;
    display: flex;
    padding-bottom: 15px;
    justify-content: space-between;
    .lft {
      width: 63.5%;
      .statistics {
        width: 100%;
        padding: 20px;
        background: #fff;
        min-height: 300px;
        .headline {
          display: flex;
          justify-content: space-between;
        }

        p {
          font-size: 14px;
          padding-left: 10px;
          display: flex;
          align-items: center;
        }
        .colorFont {
          color: #2f54eb;
          margin-left: 5px;
        }
        .cont {
          margin-top: 25px;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
          .box {
            width: 32.5%;
            padding: 15px 40px;
            border-radius: 6px;
            min-height: 98px;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            ul {
              display: flex;
              width: 100%;
              li {
                flex: 1;
                div {
                  text-align: center;
                  color: #fff;
                  font-size: 14px;
                  height: 28px;
                  line-height: 28px;
                }
              }
            }

            .img {
              flex: 3;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 85%;
              }
            }
            .flex_3_cont {
              flex: 7;
              color: #fff;
              div {
                font-size: 14px;
                height: 28px;
                line-height: 28px;
                text-align: center;
              }
            }
          }
          .box1 {
            padding-right: 40px;
            background: linear-gradient(
              180deg,
              rgba(97, 199, 253, 1) 0%,
              rgba(50, 149, 249, 1) 100%
            );
          }
          .box2 {
            padding: 0 20px;
            background: linear-gradient(180deg, #ffc46f 0%, #fd9640 100%);
          }
          .box3 {
            padding: 0 20px;

            background: linear-gradient(180deg, #fed118 0%, #efae1e 100%);
          }
          .box4 {
            padding-right: 40px;
            background: linear-gradient(
              360deg,
              rgba(2, 199, 116, 1) 0%,
              rgba(0, 209, 166, 1) 100%
            );
          }
          .box5 {
            padding-right: 40px;
            background: linear-gradient(
              180deg,
              rgba(97, 199, 253, 1) 0%,
              rgba(50, 149, 249, 1) 100%
            );
          }
          .box6 {
            padding-right: 40px;
            background: linear-gradient(
              74deg,
              rgba(73, 197, 0, 1) 0%,
              rgba(49, 209, 0, 1) 100%
            );
          }
        }
      }
      .system {
        margin-top: 10px;
        padding: 20px 30px;
        .headline {
          margin-bottom: 8px;
        }
        .tags {
          border: 1px solid rgba(0, 0, 0, 0.12);
          border-bottom: 0;
          margin-top: 5px;
          padding: 12px;
          .el-tag {
            color: #fff;
            margin-right: 10px;
          }
        }
      }
    }
    .rgt {
      width: 35.5%;
      .top {
        min-height: 313px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .todaysales {
          min-height: 150px;
          width: 100%;
          background: #fff;
          padding: 20px;
          .headline {
            text-align: center;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 22px;
              height: 22px;
              margin-right: 8px;
            }
          }
          .todaysales-cont {
            display: flex;
            width: 100%;
            margin-top: 15px;
            div {
              flex: 1;
              p {
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 36px;
                img {
                  width: 16px;
                  margin-right: 5px;
                }
              }
              .colorBule {
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(47, 84, 235, 1);
                line-height: 28px;
              }
            }
          }
        }
        .pay {
          p {
            height: 40px !important;
            background-size: contain !important;
            background-repeat: no-repeat !important;
            background-position: 20px !important;
          }
        }
      }
      .btm {
        padding: 20px 30px;
        background: #fff;
        margin-top: 10px;
        .headline {
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.75);
          line-height: 20px;
        }
        .smallhead {
          margin-top: 10px;
          height: 18px;
          font-size: 13px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(153, 153, 153, 1);
          line-height: 18px;
          margin-bottom: 10px;
        }
        .cont {
          display: flex;

          .ggCont {
            flex: 8;
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            line-height: 24px;
            height: 24px;
          }
          .ggHint {
            flex: 2;
            line-height: 24px;
            height: 24px;
            text-align: right;
            color: #2f54eb;
          }
        }
      }
    }
  }
  // .bodycontent {
  //   position: relative;
  //   padding: 20px;
  //   font-size: 14px;
  //   height: 100%;
  //   border: 1px solid #f1f1f1;
  //   box-shadow: 0 0 3px #f1f1f1;
  //   display: flex;
  //   flex-direction: column;
  //   .stat {
  //     border: 1px solid #eee;
  //     .stat_title {
  //       border-bottom: 1px solid #eee;
  //       background-color: #f5f5f5;
  //       color: #333;
  //       padding-left: 15px;
  //       font-weight: 500;
  //       height: 40px;
  //       line-height: 40px;
  //     }
  //     .stat_item {
  //       display: flex;
  //       justify-content: space-between;
  //       padding: 15px 10px;
  //       .item {
  //         flex: 1;
  //         border-radius: 5px;
  //         height: 120px;
  //         box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.07);
  //         padding: 30px;
  //         margin: 0 15px;
  //         color: #fff;
  //         .left {
  //           flex: 1;
  //         }
  //         .right {
  //           div {
  //             line-height: 30px;
  //           }
  //           .top_line {
  //             font-size: 22px;
  //           }
  //         }
  //       }
  //     }
  //   }
  //   .user {
  //     margin-top: 30px;
  //     display: flex;
  //     .user_item {
  //       box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.07);
  //       height: 220px;
  //       padding: 16px;
  //       flex: 1;
  //       border-radius: 5px;
  //       .user_title {
  //         border-bottom: 1px solid #eee;
  //         font-weight: 500;
  //         height: 30px;
  //       }
  //       .user_detail {
  //         display: flex;
  //         justify-content: space-around;
  //         padding-top: 60px;
  //         .detail_item {
  //           div {
  //             text-align: center;
  //             line-height: 30px;
  //           }
  //           .item_num {
  //             font-size: 22px;
  //             font-weight: 500;
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
}
</style>
